export default __webpack_public_path__ + "static/media/account_05.c08c49ed.png";